"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnParser = void 0;

var NonQuotedColumnParser_1 = require("./NonQuotedColumnParser");

var QuotedColumnParser_1 = require("./QuotedColumnParser");

var Token_1 = require("../Token");

var ColumnParser = /*#__PURE__*/function () {
  function ColumnParser(parserOptions) {
    _classCallCheck(this, ColumnParser);

    this.parserOptions = parserOptions;
    this.quotedColumnParser = new QuotedColumnParser_1.QuotedColumnParser(parserOptions);
    this.nonQuotedColumnParser = new NonQuotedColumnParser_1.NonQuotedColumnParser(parserOptions);
  }

  _createClass(ColumnParser, [{
    key: "parse",
    value: function parse(scanner) {
      var nextNonSpaceToken = scanner.nextNonSpaceToken;

      if (nextNonSpaceToken !== null && Token_1.Token.isTokenQuote(nextNonSpaceToken, this.parserOptions)) {
        scanner.advanceToToken(nextNonSpaceToken);
        return this.quotedColumnParser.parse(scanner);
      }

      return this.nonQuotedColumnParser.parse(scanner);
    }
  }]);

  return ColumnParser;
}();

exports.ColumnParser = ColumnParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL0NvbHVtblBhcnNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQ0EsSUFBQSx1QkFBQSxHQUFBLE9BQUEsQ0FBQSx5QkFBQSxDQUFBOztBQUNBLElBQUEsb0JBQUEsR0FBQSxPQUFBLENBQUEsc0JBQUEsQ0FBQTs7QUFFQSxJQUFBLE9BQUEsR0FBQSxPQUFBLENBQUEsVUFBQSxDQUFBOztJQUVhLFk7QUFPVCx3QkFBbUIsYUFBbkIsRUFBK0M7QUFBQTs7QUFDM0MsU0FBSyxhQUFMLEdBQXFCLGFBQXJCO0FBQ0EsU0FBSyxrQkFBTCxHQUEwQixJQUFJLG9CQUFBLENBQUEsa0JBQUosQ0FBdUIsYUFBdkIsQ0FBMUI7QUFDQSxTQUFLLHFCQUFMLEdBQTZCLElBQUksdUJBQUEsQ0FBQSxxQkFBSixDQUEwQixhQUExQixDQUE3QjtBQUNIOzs7O1dBRU0sZUFBTSxPQUFOLEVBQXNCO0FBQUEsVUFDakIsaUJBRGlCLEdBQ0ssT0FETCxDQUNqQixpQkFEaUI7O0FBRXpCLFVBQUksaUJBQWlCLEtBQUssSUFBdEIsSUFBOEIsT0FBQSxDQUFBLEtBQUEsQ0FBTSxZQUFOLENBQW1CLGlCQUFuQixFQUFzQyxLQUFLLGFBQTNDLENBQWxDLEVBQTZGO0FBQ3pGLFFBQUEsT0FBTyxDQUFDLGNBQVIsQ0FBdUIsaUJBQXZCO0FBQ0EsZUFBTyxLQUFLLGtCQUFMLENBQXdCLEtBQXhCLENBQThCLE9BQTlCLENBQVA7QUFDSDs7QUFDRCxhQUFPLEtBQUsscUJBQUwsQ0FBMkIsS0FBM0IsQ0FBaUMsT0FBakMsQ0FBUDtBQUNIOzs7Ozs7QUFwQkwsT0FBQSxDQUFBLFlBQUEsR0FBQSxZQUFBIiwic291cmNlUm9vdCI6IiJ9